<template>
  <!-- 分步骤设置密码组件 -->
  <div class="pwd-step-container">
    <div class="pwd-step-itam pwd-step-title">
      <span>{{ postContent.title }}</span>
    </div>
    <div class="pwd-step-itam pwd-step-line"></div>
    <div class="pwd-step-itam">
      <div class="pwd-step-step">
        <Step v-bind:stepContent="stepContent"></Step>
      </div>
      <div class="pwd-step-content">
        <div v-if="!hashSendSms" class="pwd-step-m-left">
          <SmsSend
            @SendSmsCode="SendSmsCode"
            @SendSmsSubmit="SendSmsSubmit"
          ></SmsSend>
        </div>
        <div v-else-if="!successed" class="pwd-step-m-left">
          <PassWordInput @SetPassWordSubmit="SetPassWordSubmit"></PassWordInput>
        </div>
        <div v-else>
          <Successed @SuccSubmit="SuccSubmit" :post="succPost"></Successed>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SendChangePwdSmsAsync,
  ChangePwdSmsCodeCheck,
  SetPassWordSubmit
} from '@/api/author'
import SmsSend from '@/components/PassWord/SmsSend'
import PassWordInput from '@/components/PassWord/PassWordInput'
import Successed from '@/components/Successed'
import Step from '@/components/Step'
export default {
  components: { SmsSend, PassWordInput, Successed, Step },
  name: 'PassWordStep',
  props: {
    post: {
      type: Object
    }
  },
  data() {
    return {
      postContent: {
        title: '设置密码'
      },
      hashSendSms: false,
      successed: false,
      succPost: {
        text: '修改密码成功',
        btnText: '完成'
      }
    }
  },
  computed: {
    stepContent() {
      return [
        {
          step: 1,
          name: '身份认证',
          isCompleted: this.hashSendSms
        },
        {
          step: 2,
          name: '设置新密码',
          isCompleted: this.hashSendSms && this.successed
        },
        {
          step: 3,
          name: '完成',
          isCompleted: this.successed
        }
      ]
    }
  },
  created() {
    Object.assign(this.postContent, this.post)
  },
  methods: {
    showError(msg) {
      if (!msg) {
        msg = '数据请求发生异常，请稍后再试。'
      }

      this.$notify.error({
        position: 'bottom-right',
        title: '错误',
        message: msg
      })
    },
    // 发送修改密码短信
    async SendSmsCode(info) {
      const { result } = await SendChangePwdSmsAsync(info.phone).catch(data => {
        console.log('error:', data)
        this.showError()
      })
      if (result.code === 0) {
        this.$notify({
          position: 'bottom-right',
          title: '成功',
          message: '短信验证码发送成功',
          type: 'success'
        })
      } else if (result.code === 100) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
    },
    // 校验短信验证码
    async SendSmsSubmit(info) {
      this.smsPhoneInfo = info
      const { result, detail } = await ChangePwdSmsCodeCheck(
        info.phone,
        info.smsCode
      )
        .catch(data => {
          console.log('error:', data)
          this.showError()
        })
        .catch(data => {
          console.log('error:', data)
          this.showError()
        })
      if (result.code === 0 && detail) {
        // 验证码校验成功
        this.hashSendSms = true
      } else if (result.code === 100) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError('验证码校验失败')
      }
    },
    // 设置密码
    async SetPassWordSubmit(info) {
      this.password = info.password

      const { result } = await SetPassWordSubmit(
        this.smsPhoneInfo.phone,
        this.smsPhoneInfo.smsCode,
        this.password
      ).catch(data => {
        console.log('error:', data)
        this.showError()
      })
      if (result.code === 0) {
        // 验证码校验成功
        this.successed = true
      } else if (result.code === 22206 || result.code === 22221) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
    },
    SuccSubmit() {
      this.$router.push('/excl-author')
    }
  }
}
</script>
<style scoped>
.pwd-step-container .pwd-step-itam .el-input__inner {
  background-color: #ffffff;
}
</style>
<style lang="scss" scoped>
.pwd-step-container {
  width: 1200px;
  height: 660px;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-content: center;
  font-family: MicrosoftYaHei;
  .pwd-step-itam {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .pwd-step-title {
    height: 70px;
    span {
      margin: 0 auto;
      display: block;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 70px;
      letter-spacing: 0px;
      color: #262626;
    }
  }
  .pwd-step-line {
    width: 1000px;
    height: 1px;
    background-color: #ebebeb;
    margin: 0 auto;
  }
  .pwd-step-step {
    display: flex;
    align-content: center;
    justify-content: center;
    margin: 50px auto;
  }
  .pwd-step-content {
    display: flex;
    align-content: center;
    justify-content: center;
    margin: 10px auto;
    .pwd-step-m-left {
      margin-left: -35px;
    }
  }
}
</style>
